import { Device } from '@goodboydigital/astro';

function matchOuterSize(w: number, h: number):boolean
{
    if (window.outerWidth < window.outerHeight)
    {
        return window.outerWidth === w && window.outerHeight === h;
    }

    return window.outerWidth === h && window.outerHeight === w;
}

export function isIPhone12Mini(): boolean
{
    if (!Device.ios) return false;

    return matchOuterSize(375, 812) && window.devicePixelRatio === 3;
}

export function isIPhone12(): boolean
{
    if (!Device.ios) return false;

    return matchOuterSize(390, 844) && window.devicePixelRatio === 3;
}

export function isIPhone12ProMax(): boolean
{
    if (!Device.ios) return false;

    return matchOuterSize(428, 926) && window.devicePixelRatio === 3;
}

export function isIPhone11(): boolean
{
    if (!Device.ios) return false;

    return matchOuterSize(414, 896) && window.devicePixelRatio === 2;
}

export function isIPhone11Pro(): boolean
{
    if (!Device.ios) return false;

    return matchOuterSize(375, 812) && window.devicePixelRatio === 3;
}

export function isIPhone11ProMax(): boolean
{
    if (!Device.ios) return false;

    return matchOuterSize(414, 896) && window.devicePixelRatio === 3;
}

export function isIPhoneX(): boolean
{
    if (!Device.ios) return false;

    return matchOuterSize(375, 812) && window.devicePixelRatio === 3;
}
